/** Full-hierarchy estimate; tab projections must not change the total. */
export function summarizeHierarchyCosts(nodes, provider) {
  const seenIds = new Set();
  const seenVaults = [];
  let total = 0;
  let componentCount = 0;
  const byTier = {};

  for (const node of nodes || []) {
    if (node?.id && seenIds.has(node.id)) continue;
    if (node?.id) seenIds.add(node.id);
    if (provider === "azure" && node?.type === "azure-key-vault") {
      const label = (node.name || "").trim().toLowerCase().replace(/\s+/g, " ");
      const region = (node.config?.region || "").toLowerCase();
      const physical = (node.config?.deployName || "").trim().toLowerCase() || null;
      if (seenVaults.some((seen) => (physical && seen.physical === physical) ||
        (label && seen.label === label && (seen.region === region || !seen.region || !region) &&
         (!physical || !seen.physical)))) continue;
      seenVaults.push({ label, region, physical });
    }
    const amount = Number(node?.config?.estMonthlyCost);
    if (!Number.isFinite(amount) || amount <= 0) continue;
    const tier = (node.config?.tier || (node.kind === "structural" ? "networking" : "compute")).toLowerCase();
    total += amount;
    byTier[tier] = (byTier[tier] || 0) + amount;
    componentCount += 1;
  }
  total = Math.round(total * 100) / 100;
  for (const tier of Object.keys(byTier)) byTier[tier] = Math.round(byTier[tier] * 100) / 100;
  return { total, componentCount, byTier };
}
